import { CheckCircleFilled } from "@ant-design/icons";
import {
  AwsIconUrl,
  AzureIconUrl,
  EntraIdIconUrl,
  GcloudIconUrl,
  GoogleWorkspaceIconUrl,
  K8sIconUrl,
  OktaIconUrl,
  PostgresIconUrl,
  SnowflakeIconUrl,
} from "@p0security/shared/integrations/constants";
import { Image, List, Typography } from "antd";
import * as React from "react";

import { Logo } from "../../Integrations/Logo";
import LinearGradientComponent from "./LinearGradientComponent";
import {
  StyledCompanyContent,
  StyledIntegrationLogo,
  StyledListContent,
  StyledSectionCol,
} from "./styles";

const { Title, Paragraph } = Typography;

const data = [
  "Grant granular least-privileged access to: AWS, Google Cloud, Azure, K8s, Snowflake, PostgreSQL, Okta and more.",
  "Automate access escalations and gain visibility into privileged access.",
  "Conduct an IAM assessment for your AWS, Google Cloud, K8s, Okta, Google Workspace, Entra ID and more.",
];

const CompanySection: React.FC = () => {
  const renderUseCase = React.useCallback(
    (item: string) => (
      <>
        <List.Item>
          <StyledListContent>
            <CheckCircleFilled />
            <Paragraph>{item}</Paragraph>
          </StyledListContent>
        </List.Item>
      </>
    ),
    []
  );
  return (
    <StyledSectionCol xs={0} md={12}>
      <Image preview={false} src={"/main_site_logo.svg"} alt="P0" width={200} />
      <StyledCompanyContent>
        <div className="bg-gradient">
          <LinearGradientComponent />
        </div>
        <Title level={4}>
          Deploy in 5 minutes, no credit card required and immediately:
        </Title>
        <List dataSource={data} size="large" renderItem={renderUseCase} />
        <StyledIntegrationLogo>
          <Logo title={"AWS"} logo={AwsIconUrl} size={30} />
          <Logo title={"Google Cloud"} logo={GcloudIconUrl} size={30} />
          <Logo title={"Azure"} logo={AzureIconUrl} size={30} />
          <Logo title={"Snowflake"} logo={SnowflakeIconUrl} size={30} />
          <Logo title={"Kubernetes"} logo={K8sIconUrl} size={30} />
          <Logo title={"PostgreSQL"} logo={PostgresIconUrl} size={30} />
          <Logo title={"Okta"} logo={OktaIconUrl} size={30} />
          <Logo title={"Entra ID"} logo={EntraIdIconUrl} size={30} />
          <Logo
            title={"Google Workspace"}
            logo={GoogleWorkspaceIconUrl}
            size={30}
          />
        </StyledIntegrationLogo>
      </StyledCompanyContent>
    </StyledSectionCol>
  );
};

export default CompanySection;
